import ExpensesPage from "./ExpensesPage";

export default ExpensesPage;
